export const detectBrowser = () => {
  const userAgentString = navigator.userAgent;
  if (userAgentString.indexOf('Chrome') > -1) return 'Chrome';
  if (userAgentString.indexOf('Firefox') > -1) return 'Firefox';
  if (userAgentString.indexOf('Safari') > -1) return 'Safari';
  return false;
};
